import { oz } from '@weft/utils';

export const NewCreateProductDialogFormSchema = oz.object({
  name: oz.string().min(1, 'Name is required'),
  description: oz.string().optional(),
});

export type NewCreateProductDialogForm = oz.TypeOf<typeof NewCreateProductDialogFormSchema>;